import { useEffect, useState } from 'react'
import { NETWORK_STATUS, useNetworkStatus } from './useNetworkStatus'
import { useUniqueCollection } from './useUniqueCollection'
import { useProvider } from '@fuel/crypto/hooks'

export enum MINT_STATUS {
  DISABLED = 'disabled',
  ALLOW_LIST = 'allow_list',
  PUBLIC = 'public',
}

export const useCurrentBlockHeight = () => {
  const { provider } = useProvider()
  const { uniqueCollection } = useUniqueCollection()
  const [mintStatus, setMintStatus] = useState(MINT_STATUS.DISABLED)
  const { networkStatus } = useNetworkStatus()
  const [currentBlockHeight, setCurrentBlockHeight] = useState(0)

  const getBlockNumber = async () => {
    try {
      if (provider && networkStatus === NETWORK_STATUS.CORRECT) {
        const data = await provider.getBlockNumber()
        return data
      }
    } catch (e) {
      console.error('Something went wrong in useCurrentBlockHeight')
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        if (uniqueCollection) {
          const startBlockHeight = await uniqueCollection.publicMintStartBlockHeight()

          const publicMintStartBlockHeight = provider && networkStatus === NETWORK_STATUS.CORRECT && startBlockHeight.toString()
          const blockHeight: any = await getBlockNumber()

          // QUESTION: Why we set the currentBlockHeight here if we dont know if its public or allowlist yet?
          // TODO: Consider stop polling if the sale not started yet

          setCurrentBlockHeight(blockHeight)
          const blockNumber: any = await getBlockNumber()
          const blocksUntilPublicMintStart = publicMintStartBlockHeight - blockNumber

          // The close we are getting to the publicMintStartBlockHeight,
          // the more  often we are polling - using quadratic curve
          if (publicMintStartBlockHeight > 0) {
            let interval = ((1 / 2000) * (publicMintStartBlockHeight - blockNumber) ** 2 + 1) * 1000

            if (interval > 300000) {
              interval = 300000
            }
            if (provider && networkStatus === NETWORK_STATUS.CORRECT && blocksUntilPublicMintStart > 0) {
              const blockNumber = setInterval(async () => {
                const blockHeight: any = await getBlockNumber()
                setCurrentBlockHeight(blockHeight)
              }, interval)

              return () => {
                clearInterval(blockNumber)
              }
            }
          }
        }
      } catch (e) {
        console.error('Something went wrong in useCurrentBlockHeight')
      }
    })()
  }, [provider, networkStatus, uniqueCollection, getBlockNumber])

  // This is the main logic for determining the mint status

  useEffect(() => {
    ;(async () => {
      if (provider && uniqueCollection && networkStatus === NETWORK_STATUS.CORRECT && currentBlockHeight !== 0) {
        const publicMintStartBlockHeight = (await uniqueCollection.publicMintStartBlockHeight()).toString()
        const allowListMintEndBlockHeight = +(await uniqueCollection.allowListMintEndBlockHeight()).toString()
        const isAllowListMint = currentBlockHeight <= +allowListMintEndBlockHeight && allowListMintEndBlockHeight > 0
        const isPublicListMint = publicMintStartBlockHeight > 0 && publicMintStartBlockHeight <= currentBlockHeight

        console.log('isAllowListMint', isAllowListMint)
        console.log('isPublicListMint', isPublicListMint)

        if (isAllowListMint) {
          setMintStatus(MINT_STATUS.ALLOW_LIST)
        } else if (isPublicListMint) {
          setMintStatus(MINT_STATUS.PUBLIC)
        } else {
          setMintStatus(MINT_STATUS.DISABLED)
        }
      }
    })()
  }, [provider, uniqueCollection, networkStatus, currentBlockHeight])

  return { mintStatus }
}
